import { UPDATE_WELLNESS_MODAL } from "./update-wellness-modal.query";
import { useApolloClient } from "@apollo/client";

export const useUpdateModalStatus = () => {
  const client = useApolloClient();

  const updateWellnessModalCheck = () => {
    void client
      .query({
        query: UPDATE_WELLNESS_MODAL,
        fetchPolicy: "network-only",
        context: { fetchOptions: { keepalive: true } },
      })
      .catch(() => {
        // Handled centrally by errorLink; no-op here.
      });
  };

  return { updateWellnessModalCheck };
};
